import React from 'react'

const AnalyticsDataWrapper: React.FunctionComponent<IAnalyticsDataWrapperProps> = ({
  children,
  ...props
}) => <div {...props}>{children}</div>

interface IAnalyticsDataWrapperProps {
  [key: string]: unknown
}

export default AnalyticsDataWrapper
